<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-price-tag"></i>
                </div>
                <div class="header-text">
                    <h2>讲师标签</h2>
                    <p>讲师管理 · 标签配置管理</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input
                            v-model="formDatas.atlName"
                            placeholder="搜索标签名称"
                            clearable
                            size="medium"
                            class="ai-input"
                            @keyup.enter.native="partserch"
                        ></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增标签
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        标签列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            讲师标签管理
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage"  :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="atlId" stripe
                        @page-change="handlePageChange" @operate-btn-click="handleOperateBtnClick"
                        @selection-change="handleSelectionChange">
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_label" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增标签信息" dialogWidth="600px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val"
            @item-change="handleItemChange">
        </aj-form-add>
        <aj-form-edit ref="edit_label" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑标签信息" labelWidth="100px"
            @confirm="handleEditConfirm">
        </aj-form-edit>
    </div>
</template>

<script>
import {
    getAjTeacherLabelList,
    addAjTeacherLabel,
    updateAjTeacherLabel,
    deleteAjTeacherLabel
} from "../../api/api";

export default {
    name: "lecturerLabel",
    components: {},
    data() {
        return {
            tableHeight:null,
            addDialogVisible: false,
            editDialogVisible: false,
            form: {},
            formConfig: [],
            totalCount: 0,
            tableData: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, fixed: 'left' },
                { label: '标签名称', prop: 'atlName', align: 'center', fixed: 'left' },
                { label: '排序', prop: 'atlOrder', width: 100, align: 'center' },
                { label: '创建时间', prop: 'createtime', width: 180, align: 'center' },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 180,
                    buttons: [
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete' }
                    ]
                }
            ],
            tableEditable: false,

            formDatas: {
                atlName: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },

    created() {

        this.partserch();
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset:120 });
            });
        },
        //
        // 表单配置项
        getFormInit() {
            this.formConfig = [
                [{ type: 'input', label: '标签名称', prop: 'atlName', placeholder: '请输入标签名称', span: 24, required: true }],
                [{ type: 'input', label: '排序', prop: 'atlOrder', placeholder: '请输入排序数字', span: 24, required: false, inputType: 'number' }],
            ];
            this.form = {
                atlName: '',
                atlOrder: 0,
            };
        },
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该标签吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                updateAjTeacherLabel(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_label.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '编辑失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },
        // 表单项变更监听
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            try {
                await this.$confirmDialog({
                    content: '确认新增该标签吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                addAjTeacherLabel(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_label.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '新增失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        addForm() {
            this.getFormInit();
            this.addDialogVisible = true;
        },

        // 分页切换回调
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            this.getListData();
        },

        // 操作按钮点击回调
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
            }
        },
        // 选中状态变化回调
        handleSelectionChange(selRows) {
            console.log('当前页选中行：', selRows.map(row => row.id));
        },
        // 编辑操作
        handleEdit(row) {
            this.getFormInit();
            const s = JSON.parse(JSON.stringify(row));
            this.form = s;
            this.editDialogVisible = true;
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该标签吗？',
                    type: 'danger'
                });
                deleteAjTeacherLabel({ atlId: row.atlId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        // 获取列表数据
        getListData() {
            getAjTeacherLabelList(this.formDatas).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data || [];
                    this.totalCount = res.total || 0;
                }
            });
        },

        partserch() {
            this.formDatas.currentPage = 1;
            this.getListData();
        },
        resetSearch() {
            this.formDatas.atlName = '';
            this.partserch();
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(14, 165, 233, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(14, 165, 233, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #f59e0b;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #fffbeb;
    border-radius: 20px;
}

/* Search Card */
.search-card {
    grid-column: span 1;
}

.search-row {
    display: flex;
    gap: 12px;
    align-items: center;
}

.search-input-wrapper {
    flex: 1;
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #0ea5e9;
    background: white;
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

/* Table Card */
.table-card {
    width: 100%;
    min-height: 400px;
}

.card-content {
    padding: 4px 0;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}
</style>
